import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import strings from 'owa-strings/owa-mail-strings';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function createMailDataProvider(): AttachmentDataProvider {
    const mailProviderScope: AttachmentDataProviderScope = {
        __type: 'MailMessage',
        DisplayName: strings.InboxText,
        AriaLabel: strings.InboxText,
    };

    const mailProviderModel: AttachmentDataProvider = {
        __type: 'MailMessageAttachmentDataProvider',
        Id: 'MailMessage',
        Type: AttachmentDataProviderType.MailMessage,
        DisplayName: strings.MailMessageFileProviderDisplayName,
        AssociatedDataProviderAccountId: null,
        Scopes: [mailProviderScope],
        DefaultScopeIndex: 0,
        AllowFolderSharing: false,
        DefaultPermissionType: AttachmentPermissionLevel.OrganizationEdit, // Not used in this case
        IsSearchSupported: isFeatureEnabled('doc-filePicker-mailMessageSearch'),
        IsThirdPartyProvider: false,
    };

    return mailProviderModel;
}
